const colours = {
    'white': '#FFFFFF',
    'black': '#000000',
    'red': '#FF242A',
    'red-aa': '#EB0008',
    'red-20': '#FFC0B5',
    'red-10': '#FFE9E9',
    'blush': '#F5A091',
    'earth-dark': '#6E3737',
    'earth': '#91504B',
    'sand': '#F0EBDD',
    'pebble': '#F6F4EE',
    'grey': '#F9F3F3',
    'charcoal': '#4F3E3F',
    'charcoal-80': '#695B5C',
    'charcoal-60': '#A18989',
    'charcoal-40': '#CAB2B2',
    'charcoal-20': '#F3DDDE',
}

export {
    colours,
}
